import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Divider,
    Button
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { data, options } from './chart';
import DateRangePickers from '../DateRangePickers';
import palette from '../../../../../theme/palette';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    root: {},
    chartContainer: {
        height: 500,
        position: 'relative'
    },
    actions: {
        justifyContent: 'flex-end'
    }
}));

const LatestSales = props => {
    const { className, ...rest } = props;

    const classes = useStyles();

    data.datasets = []
    data.labels = []


    let isVlrPlay = false, isVlrSpotify = false, isVlrItunes = false, isVlrGoogle = false;

    //iterar para pegar os meses 
    let labels = [];
    props.reproducoes.player.forEach(item => {
        isVlrPlay = true
        let label = moment(new Date(moment(Number(item.dateAcesso)))).format('DD/MM/YY')
        if (labels.indexOf(label) == -1)
            labels.push(label)
    });

    props.reproducoes.spotify.forEach(item => {
        isVlrSpotify = true
        let label = moment(new Date(moment(Number(item.dateAcesso)))).format('DD/MM/YY')
        if (labels.indexOf(label) == -1)
            labels.push(label)
    });

    props.reproducoes.itunes.forEach(item => {
        isVlrItunes = true
        let label = moment(new Date(moment(Number(item.dateAcesso)))).format('DD/MM/YY')
        if (labels.indexOf(label) == -1)
            labels.push(label)
    });

    props.reproducoes.google.forEach(item => {
        isVlrGoogle = true
        let label = moment(new Date(moment(Number(item.dateAcesso)))).format('DD/MM/YY')
        let indexOf = labels.indexOf(label)

        if (indexOf == -1)
            labels.push(label)
    });

    data.labels = labels
    ///

    //tribuir valores
    //PLAY
    if (isVlrPlay) {
        let valDatasetPlay = [];
        for (let index = 0; index < labels.length; index++) {
            valDatasetPlay.push(0);
        }
        props.reproducoes.player.forEach(item => {

            let label = moment(new Date(moment(Number(item.dateAcesso)))).format('DD/MM/YY')
            const index = labels.indexOf(label)
            if (index > -1)
                valDatasetPlay[index] += item.count;
        });

        let dataSetsPlay = {
            label: 'Player',
            backgroundColor: palette.primary.main,
            data: valDatasetPlay
        }

        data.datasets.push(dataSetsPlay)
    }

    //PLAY


    //Spotify
    if (isVlrSpotify) {
        let valSpotify = [];
        for (let index = 0; index < labels.length; index++) {
            valSpotify.push(0);
        }
        props.reproducoes.spotify.forEach(item => {

            let label = moment(new Date(moment(Number(item.dateAcesso)))).format('DD/MM/YY')
            const index = labels.indexOf(label)
            if (index > -1)
                valSpotify[index] += item.count;
        });

        let dataSetsSpotify = {
            label: 'Spotify',
            backgroundColor: palette.agregadores.spotify,
            data: valSpotify
        }
        data.datasets.push(dataSetsSpotify)
    }
    //Spotify

    //itunes
    if (isVlrItunes) {
        let valItunes = [];
        for (let index = 0; index < labels.length; index++) {
            valItunes.push(0);
        }
        props.reproducoes.itunes.forEach(item => {

            let label = moment(new Date(moment(Number(item.dateAcesso)))).format('DD/MM/YY')
            const index = labels.indexOf(label)
            if (index > -1)
                valItunes[index] += item.count;
        });

        let dataSetsItunes = {
            label: 'iTunes',
            backgroundColor: palette.agregadores.itunes,
            data: valItunes
        }
        data.datasets.push(dataSetsItunes)
    }
    //Spotify



    //google
    if (isVlrGoogle) {
        let valGoogle = [];
        for (let index = 0; index < labels.length; index++) {
            valGoogle.push(0);
        }
        props.reproducoes.google.forEach(item => {

            let label = moment(new Date(moment(Number(item.dateAcesso)))).format('DD/MM/YY')
            const index = labels.indexOf(label)
            if (index > -1)
                valGoogle[index] += item.count;
        });

        let dataSetsGoogle = {
            label: 'Google',
            backgroundColor: palette.agregadores.google,
            data: valGoogle
        }
        data.datasets.push(dataSetsGoogle)
    }
    //google 


    return (
        <Card className={clsx(classes.root, className)}>

            <CardHeader action={<DateRangePickers changerangedata={props.changerangedata}></DateRangePickers>} />
            <Divider />
            <CardContent>
                <div className={classes.chartContainer}>
                    <Bar data={data} options={options} />
                </div>
            </CardContent>
            <Divider />
            <CardActions className={classes.actions}>
                <Button
                    color="primary"
                    size="small"
                    variant="text" >
                    <ArrowRightIcon style={{ visibility: "hidden" }} />
                </Button>
            </CardActions>
        </Card>
    );
};

LatestSales.propTypes = {
    className: PropTypes.string
};

export default LatestSales;
